import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import PopupHeader from './popupComponents/PopupHeader';

import './styles.scss';

const Popup = (
  {
    closeCallBack,
    children,
    popupId,
    classCustom,
    headerText,
    size,
    withClose,
    autoCloseTime,
    closePopup,
  },
) => {
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (autoCloseTime) {
      const autoCLoseTimeout = setTimeout(() => {
        closePopup(popupId);
      }, autoCloseTime);

      return () => {
        clearTimeout(autoCLoseTimeout);
      };
    }
  }, [autoCloseTime, popupId, closePopup]);

  return (
    <div className='popup'>
      <div className={`popup-block popup-${size} ${popupId} ${classCustom} ${headerText && 'popup-block--with-header'}`}>
        <div className='popup-in'>
          <PopupHeader withClose={withClose} popupId={popupId} text={headerText} closeCallBack={closeCallBack}/>
          <div className='popup-content'>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

Popup.defaultProps = {
  classCustom: '',
  headerText: '',
  size: 'big',
  withClose: true,
  closeCallBack: () => {
  },
  autoCloseTime: 0,
};

Popup.propTypes = {
  classCustom: PropTypes.string,
  popupId: PropTypes.string.isRequired,
  headerText: PropTypes.string,
  size: PropTypes.string,
  withClose: PropTypes.bool,
  closeCallBack: PropTypes.func,
  autoCloseTime: PropTypes.number,
};

export default Popup;
